import { get } from 'src/services/api';

const getCampaignRolesPermissions = async () => (await get(`permissions/campaign-roles-permissions`)).data;


export {
  getCampaignRolesPermissions,
};
